<template>
  <div v-show="active">
    <slot v-bind:active="active">Base tab control content item</slot>
  </div>
</template>
is
<script>
export default {
  props: {
    tabIndex: {
      required: true,
      type: Number
    }
  },
  computed: {
    active() {
      const { value } = this.getTabState();
      return value === this.tabIndex;
    }
  },
  inject: ["getTabState"]
};
</script>

<style lang="scss" scoped></style>
